import type { Api } from '@/typings/api';
const otherUrl = JSON.parse(import.meta.env.VITE_OTHER_SERVICE_BASE_URL);

/**
 * 获取文件URL
 *
 * @param url URL
 */
export async function getUrl(
  attachment: Api.Base.Attachment,
  isThumbnail = false,
  imgConfig: {
    style: 'style-1024' | 'style-512';
  } = {
    style: 'style-1024'
  }
) {
  if (!attachment) return '';
  if (isThumbnail && attachment.thUrl) {
    return attachment.thUrl;
  }
  if (attachment.platform?.includes('-oss') || attachment.platform?.includes('-obs')) {
    if (attachment.ext && ['jpg', 'jpeg', 'png', 'gif'].includes(attachment.ext.toLowerCase())) {
      return `${attachment.url}?x-image-process=style/${imgConfig.style}`;
    }
    return attachment.url;
    // return (await generateDownloadUrl(attachment.id)).data
  }
  return `${otherUrl.file}/${attachment.url}`;
}
